<span class="button" *ngIf="stateHistory?.length > 1" (click)="action('UNDO')" [class.disabled]="stateHistory.indexOf( activeState ) === 0" ><i class="fa fa-undo"></i> {{ 'UNDO' | translate }}</span>
<span class="button" *ngIf="displayVersions" [class.active]="showVersions" (click)="showVersions = !showVersions"> <i class="fa fa-list"></i> </span>
<span class="button" *ngIf="stateHistory?.length > 1" (click)="action('REDO')" [class.disabled]="stateHistory.indexOf( activeState ) === (stateHistory.length - 1)">{{ 'REDO' | translate }} &nbsp;&nbsp;<i class="fa fa-repeat"></i></span>
<div class="states" *ngIf="stateHistory" [hidden]="!showVersions">
	<h3>{{ 'ACTION_HISTORY' | translate }}</h3>
	<div class="state-item" [class.active-state]="state === activeState"
		*ngFor="let state of stateHistory; let i = index;"
		(click)="action('GOTOSTATE', state)">
			{{ i + 1 }} {{ state.fromCommand | translate }}
			<!-- <span [innerHTML]="state.timestamp | bbDate:'relative'"></span> -->
	</div>
</div>
